
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <div class="text-center mb-4">
            <h4 class="fw-bold">Resend Confirmation Link?</h4>
            <p>Enter your email and we'll send you a confirmation link.</p>
          </div>
          <form [formGroup]="resendConfirmLinkForm" (ngSubmit)="submit()" novalidate>
            <div class="form-group mb-2">
              <label class="form-label" for="email">Your email</label>
              <input type="email" class="form-control" MyInput placeholder="Email" formControlName="email" id="email">
              <my-error controlName="email" errorKey="required">Email is required.</my-error>
              <my-error controlName="email" errorKey="email">Please enter a valid email.</my-error>
              <p class="text-muted">
                <small>We'll send password confirmation link to your email.</small>
              </p>
            </div>
            <div class="form-group mb-2">
              <button class="btn btn-primary btn-lg btn-block mt-3" [disabled]="!resendConfirmLinkForm.valid || loading"
                type="submit">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="loading"></span>
                Submit
              </button>
            </div>
            <div class="mt-3 text-center">
              <a class="link-primary text-decoration-none fw-bold" [routerLink]="['/account/login']">
                <span class="mb-1"><i-bs name="arrow-left-short" width="1em" height="1em"></i-bs></span>
                <span class="mr-1"> Return to Login</span>
              </a>
            </div>
          </form>
        </div>
      </div>